// import React, {  useEffect } from 'react';
// import { Table, Row, Col, Card, CardBody, CardTitle, CardHeader} from 'reactstrap';

// import {connect} from "react-redux"
// import {getSession} from "../../../Redux/Actions/USER/user"
// import {useParams} from "react-router-dom"
// const Dial = ({session, getSession})=>{
//     const {id} = useParams()
//     useEffect(()=>{
//         getSession(id)

//       }, [])

//       useEffect(()=>{
//         console.log("session====================",session)
        
//       }, [session])
     
//      return  <Row className="justify-content-center">
//         <Col xs="12" sm="12">
//           <Card>
             
//             <CardBody>
//              <Table responsive bordered striped>
//               <thead>
//                 <tr>
//                   <th>#</th>
//                   <th>Call</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {session && session.map((item, i)=>(
//                      <tr>
//                         <td>{i+1}</td>
//                         <td>{(item.call)/60} mins</td>
//                      </tr>
//                 )) }
//               </tbody>
//             </Table>
//              </CardBody>
//           </Card>
//         </Col>
//       </Row>
    
      
// }

// const mapStateToProps = state => ({
//     session: state.bulk.session,
// });
// export default connect(
//   mapStateToProps,
//   {getSession}
// )(Dial);

import React, { useEffect } from 'react';
import { Table, Row, Col, Card, CardBody } from 'reactstrap';
import { connect } from "react-redux";
import { getSession } from "../../../Redux/Actions/USER/user";
import { useParams } from "react-router-dom";

const Dial = ({ session, getSession }) => {
    const { id } = useParams();

    useEffect(() => {
        getSession(id);
    }, [id]);

    useEffect(() => {
        console.log("session====================", session);
    }, [session]);

    // Sort sessions in descending order based on the createdAt field
    const sortedSessions = session ? [...session].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];

    // Inline CSS for table layout
    // const tableStyle = {
    //     width: '100%',
    //     tableLayout: 'fixed',
    //     marginBottom: '20px',
    // };

    // const cellStyle = {
    //     padding: '8px',
    //     textAlign: 'left',
    //     wordWrap: 'break-word',
    // };

    // const thStyle = {
    //     backgroundColor: '#f8f9fa',
    //     fontWeight: 'bold',
    // };

       // Function to format the date as '01:11 AM at dd-mm-yyyy'
       const formatDate = (dateString) => {
        const date = new Date(dateString);
    
        // Get the hours, minutes, and seconds (in local time)
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    
        // Get the day, month, and year
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
    
        // Format the final output as 'hh:mm AM/PM at dd-mm-yyyy'
        return `${day}-${month}-${year} at ${formattedHours}:${formattedMinutes} ${ampm} `;
    };

    return (
        <Row className="justify-content-center">
            <Col xs="12" sm="12">
                <Card>
                    <CardBody>
                        <Table responsive bordered striped 
                        // style={tableStyle}
                        >
                            <thead>
                                <tr>
                                    <th 
                                    // style={thStyle}
                                    >SNo.</th>
                                                                        <th
                                                                        //  style={thStyle}
                                                                        >Date</th> {/* Added Date column */}

                                    <th 
                                    // style={thStyle}
                                    >Calls Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedSessions.map((item, i) => (
                                    <tr key={item._id}>
                                        <td 
                                        // style={cellStyle}
                                        >{i + 1}</td>

<td >{formatDate(item.createdAt)}</td>  

                                        <td 
                                        // style={cellStyle}
                                        >{(item.call / 60).toFixed(2)} mins</td> {/* Call duration with 2 decimal places */}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}

const mapStateToProps = state => ({
    session: state.bulk.session,
});

export default connect(
    mapStateToProps,
    { getSession }
)(Dial);

